export default (theme) => ({
    styleOverrides: {
        filledInfo: {
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
        },
    },
});
